export const FETCH_PROJECT_RESULTS_SUCCEEDED = 'FETCH_PROJECT_RESULTS_SUCCEEDED'
export const FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED = 'FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED'
export const NEW_PROJECT_CREATED = 'NEW_PROJECT_CREATED'